import "./Navbar.css";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../../Assets/logo.png";
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
  FaYoutube,
} from "react-icons/fa";
import { FaLocationDot, FaXTwitter } from "react-icons/fa6";
import { LuChartNoAxesGantt, LuX } from "react-icons/lu";
import { getContactPage, getSocialMedia } from "../../Redux/Slices/AppSlices";
import { useDispatch, useSelector } from "react-redux";
import PosterView from "./PosterView";

const Navbar = () => {
  const dispatch = useDispatch();
  const { contactPage, socialMedia } = useSelector((state) => state.app);

  useEffect(() => {
    dispatch(getContactPage());
    dispatch(getSocialMedia());
  }, []);
  const navigate = useNavigate();
  const [navActive, setNavActive] = useState(false);
  const handleToggleNav = () => {
    setNavActive(true);
  };

  const [sticky, setSticky] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const triggerPoint = window.innerHeight * 0.1; // 10% of screen height

      if (scrollPosition > triggerPoint) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="nabvar">
      <nav className={`nav headr-comp ${sticky ? "sticky" : ""}`}>
        <div className="nav-top-main">
          <div className="nav-top landing-pages">
            <div className="nav-contact">
              <Link to={`mailto: ${contactPage?.email}`}>
                <FaEnvelope /> {contactPage?.email}
              </Link>
              <Link to={`tel: ${contactPage?.phone}`}>
                <FaPhoneAlt /> {contactPage?.phone}
              </Link>
            </div>
          </div>
        </div>
        <div className="landing-pages nav-box">
          <div className="nav-left">
            <img className="nav-logo" src={logo} alt="" />
          </div>
          <div className={`nav-center ${navActive ? "active" : ""}`}>
            <div className="nav-items">
              <NavLink
                onClick={() => setNavActive(false)}
                className={({ isActive }) => (isActive ? "nav-active" : "")}
                to="/"
              >
                {" "}
                Home
              </NavLink>
              <NavLink
                onClick={() => setNavActive(false)}
                className={({ isActive }) => (isActive ? "nav-active" : "")}
                to="/about"
              >
                About
              </NavLink>
              <NavLink
                onClick={() => setNavActive(false)}
                className={({ isActive }) => (isActive ? "nav-active" : "")}
                to="/programs"
              >
                {" "}
                Programs
              </NavLink>
              <NavLink
                onClick={() => setNavActive(false)}
                className={({ isActive }) => (isActive ? "nav-active" : "")}
                to="/admissions"
              >
                {" "}
                Admissions
              </NavLink>
              <NavLink
                onClick={() => setNavActive(false)}
                className={({ isActive }) => (isActive ? "nav-active" : "")}
                to="/gallery"
              >
                {" "}
                Gallery
              </NavLink>
              <NavLink
                onClick={() => setNavActive(false)}
                className={({ isActive }) => (isActive ? "nav-active" : "")}
                to="/contact"
              >
                Contact
              </NavLink>
            </div>
            <LuX
              className="nav-togle close-btn"
              onClick={() => setNavActive(false)}
            />
            <div className="nav-contact responsive">
              <Link to={`mailto: ${contactPage?.email}`}>
                <FaEnvelope /> {contactPage?.email}
              </Link>
              <Link to={`tel: ${contactPage?.phone}`}>
                <FaPhoneAlt /> {contactPage?.phone}
              </Link>
              <div className="nav-contact nav-socialmedia responsive">
                {socialMedia?.socialMediaItems?.map((item) => {
                  let Icon = null;

                  if (item.title === "facebook") {
                    Icon = <FaFacebookF />;
                  }

                  if (item.title === "twitter") {
                    Icon = <FaXTwitter />;
                  }

                  if (item.title === "linkedIn") {
                    Icon = <FaLinkedinIn />;
                  }
                  if (item.title === "instagram") {
                    Icon = <FaInstagram />;
                  }
                  if (item.title === "youtube") {
                    Icon = <FaYoutube />;
                  }

                  return (
                    <Link key={item.id} to={item.link || "#"} target="_blank">
                      {Icon}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="nav-right">
            <div className="nav-contact nav-socialmedia">
              {socialMedia?.socialMediaItems?.map((item) => {
                let Icon = null;
                if (item.title === "facebook") {
                  Icon = <FaFacebookF />;
                }
                if (item.title === "twitter") {
                  Icon = <FaXTwitter />;
                }
                if (item.title === "linkedIn") {
                  Icon = <FaLinkedinIn />;
                }
                if (item.title === "instagram") {
                  Icon = <FaInstagram />;
                }
                if (item.title === "youtube") {
                  Icon = <FaYoutube />;
                }
                return (
                  <Link key={item.id} to={item.link || "#"} target="_blank">
                    {Icon}
                  </Link>
                );
              })}
            </div>
            <LuChartNoAxesGantt
              className="nav-togle"
              onClick={() => handleToggleNav()}
            />
          </div>
        </div>
      </nav>
      <div className="floating-menu-btn" onClick={() => setSidebarOpen(true)}>
        <LuChartNoAxesGantt /> <span>Highlights</span>
      </div>
      <div
        className={`sidebar-overlay ${sidebarOpen ? "active" : ""}`}
        onClick={() => setSidebarOpen(false)}
      >
        <div className="sidebar-popup" onClick={(e) => e.stopPropagation()}>
          <LuX
            className="sidebar-close"
            onClick={() => setSidebarOpen(false)}
          />

          <div className="sidebar-content">
            <PosterView />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
